import { Link } from 'react-router-dom';
import { ArrowRight, Home, Clock, ShieldAlert } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useSiteContent } from '../context/SiteContentContext';

export default function RateLimitPage() {
  const { language, localizedPath } = useSiteContent();
  
  const contentMap = {
    bg: {
      title: 'Твърде много заявки.',
      subtitle: 'Засечена е необичайна активност,',
      subtitleHighlight: 'моля изчакайте малко.',
      description: 'За вашата сигурност ограничаваме броя на заявките. Опитайте отново след няколко минути.',
      backHome: 'Към началото',
      tryAgain: 'Опитай отново'
    },
    en: {
      title: 'Too many requests.',
      subtitle: 'Unusual activity detected,',
      subtitleHighlight: 'please wait a moment.',
      description: 'For your security, we limit the number of requests. Please try again in a few minutes.',
      backHome: 'Back to Home',
      tryAgain: 'Try Again'
    },
    de: {
      title: 'Zu viele Anfragen.',
      subtitle: 'Ungewöhnliche Aktivität erkannt,',
      subtitleHighlight: 'bitte warten Sie einen Moment.',
      description: 'Zu Ihrer Sicherheit begrenzen wir die Anzahl der Anfragen. Bitte versuchen Sie es in einigen Minuten erneut.',
      backHome: 'Zur Startseite',
      tryAgain: 'Erneut versuchen'
    }
  };
  const content = contentMap[language] || contentMap.en;
  
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-20">
      <div className="max-w-2xl mx-auto text-center">
        {/* 429 with Icon */}
        <div className="relative inline-block mb-4">
          <h1 className="text-7xl sm:text-8xl md:text-9xl font-extrabold text-slate-200">
            429
          </h1>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-[#C41E3A]/10 rounded-full flex items-center justify-center">
              <ShieldAlert className="w-8 h-8 sm:w-10 sm:h-10 text-[#C41E3A]" />
            </div>
          </div>
        </div>
        
        {/* Main Message */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-900 mb-4">
          {content.title}
        </h2>
        
        {/* Subtitle */}
        <p className="text-lg sm:text-xl text-slate-600 mb-4 max-w-md mx-auto">
          {content.subtitle}
          <br />
          <span className="text-[#C41E3A] font-semibold">{content.subtitleHighlight}</span>
        </p>
        
        {/* Description */}
        <p className="text-slate-500 mb-8 max-w-md mx-auto flex items-center justify-center gap-2">
          <Clock className="w-4 h-4" />
          {content.description}
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to={localizedPath('/')}>
            <Button className="bg-[#C41E3A] hover:bg-[#A01830] text-white px-6 py-3 rounded-full flex items-center gap-2">
              <Home className="w-4 h-4" />
              {content.backHome}
            </Button>
          </Link>
          <Button 
            variant="outline" 
            className="border-2 border-[#C41E3A] text-[#C41E3A] hover:bg-[#C41E3A] hover:text-white px-6 py-3 rounded-full flex items-center gap-2"
            onClick={() => window.location.reload()}
          >
            {content.tryAgain}
            <ArrowRight className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
